import { connect } from "knockout-store";
import snackbar from "./snackbar";
import { t } from "../../utils/translations";

function modalViewModel(params) {
  if (params.isMobile() && !params.mobileToastChecked()) {
    snackbar(() => {
      params.mobileToastChecked(true);
    });
  }

  params.isMobile.subscribe((value) => {
    if (value && !params.mobileToastChecked()) {
      snackbar(() => {
        params.mobileToastChecked(true);
      });
    }
  });

  const vm = {};
  vm.translation = (key) => t(key);
  return vm;
}

function mapStateToParams({ route, isMobile, mobileToastChecked }) {
  return { route, isMobile, mobileToastChecked };
}

export default connect(mapStateToParams)(modalViewModel);
